import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
  ViewChildren
} from '@angular/core';

import {BsModalService} from "ngx-bootstrap/modal";
import {OrganisationService} from "../../../services/organisation/organisation.service";

import {TeamsAddEditComponent} from "../../../components/teams-add-edit/teams-add-edit.component";
import {TeamsManageUsersComponent} from "../../../components/teams-manage-users/teams-manage-users.component";
import {TeamsRemoveTeamComponent} from "../../../components/teams-remove-team/teams-remove-team.component";
import {AlertBannerService, AlertType} from "../../../lib/alert-banner";
import {PermissionsService} from "../../../services/permissions/permissions.service";

@Component({
  selector: 'app-teams-settings',
  templateUrl: './teams-settings.component.pug',
  styleUrls: ['./teams-settings.component.scss'],
  standalone: false
})
export class TeamsSettingsComponent implements OnInit {

  @Input() showInitials = false;
  @Input() type = 'reference';
  @Input() questionnairePermissions = false;
  @Input() noAccessTooltip = '';

  @Output() clickNameEvent = new EventEmitter<any>();

  TopRowGrid1Label = $localize`Users`;
  teamData: any;
  dropDownOptions = [
    {key: 1, value: $localize`Edit team`, divider: false },
    {key: 2, value: $localize`Manage users`, divider: false },
    {key: 3, value: $localize`Remove team`, divider: true }
  ];

  cursorType = '';
  tooltipOn = false;
  nameClicked = false;
  ent5437RequestCards = true;
  clickFlag = false;
  teamsLoaded = false;
  total = 0;
  queryData = '';
  currentPage = 1;
  rowsPerView = 20;
  sortString = 'name';
  private bsModalRef: any;
  label = '';
  kebabMenuOpen = false;
  @ViewChild('teamsContainer') teamContainer:any;
  @ViewChild('teamDropdown') teamDropdown:any;
  @ViewChildren('teamCardMenu') kebabMenus:any;

  get groupDropDownOptions() {
    return [
      {
        key: $localize`Team`,
        value: [
          {'label': $localize`A-Z`, 'sortString': 'name'},
          {'label': $localize`Z-A`, 'sortString': '-name'}
        ]
      },
      {
        key: 'group-end',
        value: []
      },
      {
        key: $localize`Users`,
        value: [
          { label: $localize`Highest`, sortString: '-total_number_of_users' },
          { label: $localize`Lowest`, sortString: 'total_number_of_users' },
        ]
      }
    ];
  }

  constructor(
    private modalService: BsModalService,
    public organisationService: OrganisationService,
    private alertList: AlertBannerService,
    private permissions: PermissionsService,
  ) {
  }

  ngOnInit(): void {
    this.label = `${this.groupDropDownOptions[0].key} (${this.groupDropDownOptions[0].value[0].label})`;
    this.getAndProcessTeamsList();
  }

  onMenuStateChange(isOpen: boolean): void {
    this.kebabMenuOpen = isOpen;
  }

  getAndProcessTeamsList(){

    this.teamsLoaded = false;

    this.organisationService.listTeam(this.queryData, this.rowsPerView, this.currentPage, this.sortString).subscribe({
        next: response => {
          this.teamData = response['teams'];
          this.total = response['total'];
          this.teamsLoaded = true;
          },
        error: response => {
          this.teamsLoaded = true;
          },    // errorHandler
        complete: () => { }, // completeHandler
      });

  }

  onSortChange(event: any){
    this.sortString = event.sortString;
    this.getAndProcessTeamsList();
    this.label = `${event.key} (${event.label})`;
  }

  onClickAddTeam(){
    const initialState = {
      popupType: 'add-team'
    }
    this.bsModalRef = this.modalService.show(TeamsAddEditComponent, {
      class: 'modal-dialog-centered m-popup', initialState
    });

     // Subscribe to onHidden event
    this.bsModalRef.content?.closeEvent?.subscribe((reason: string | any) => {
      if (reason === 'team-added') {
        this.getAndProcessTeamsList();
      }
    });
  }

  teamCardMenuEvent(event: {key: number},
                    eachTeam: {id: number, default_team: boolean, name: string, total_number_of_users: number}) {
    if (event.key === 1){
      const initialState = {
        popupType: 'edit-team',
        teamName: eachTeam.name,
        teamId: eachTeam.id,
      }
      this.bsModalRef = this.modalService.show(TeamsAddEditComponent, {
        class: 'modal-dialog-centered m-popup', initialState
      });

    }
    else if (event.key === 2){
      const initialState = {
        teamName: eachTeam.name,
        teamId: eachTeam.id,
      }
      this.bsModalRef = this.modalService.show(TeamsManageUsersComponent, {
        class: 'modal-dialog-centered xl-popup', initialState
      });
    }
    else if (event.key === 3){
      const initialState = {
        teamName: eachTeam.name,
        teamId: eachTeam.id
      }
      this.bsModalRef = this.modalService.show(TeamsRemoveTeamComponent, {
        class: 'modal-dialog-centered m-popup', initialState
      });
    }

    this.bsModalRef.content?.closeEvent?.subscribe((reason: string | any) => {
      if (reason === 'team-updated' || reason === 'team-removed' ) {
        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: $localize`Success! Changes have been saved.`,
          keepOnRouteChange: true
        }]);
        this.getAndProcessTeamsList();
      }
      else if (reason.substring(0, 19) === 'team-users-modified') {
        eachTeam.total_number_of_users = reason.substring(20);
      }
    });
    return event
  }

  checkOverflow(element: any): boolean {
    return element.offsetWidth < element.scrollWidth;
  }


  onPageChange(page: number ): void {
    if(this.currentPage != page){
      this.currentPage = page;
      this.getAndProcessTeamsList();
    }
  }

  onPageSizeChange(rows: number): void {
    this.rowsPerView = rows;
    this.currentPage = 1;
    this.getAndProcessTeamsList();
  }

  ngAfterViewInit() {
    const container = document.querySelector('.list');
    if (container) {
      container.addEventListener('scroll', this.onScroll.bind(this));
    }
  }

  ngOnDestroy() {
    const container = document.querySelector('.list');
    if (container) {
      container.removeEventListener('scroll', this.onScroll.bind(this));
    }
  }

  onScroll(): void {
    if (this.kebabMenuOpen) {
      this.teamContainer.nativeElement.click()
      const kebabMenusArray = this.kebabMenus.toArray();
      kebabMenusArray.forEach((kebabMenu: ElementRef) => {
        const button = kebabMenu.nativeElement.children[0]?.children[0]?.children[0];
        if (button) {
          button.blur();
        }
      });
    }
    const dropdownSection = this.teamDropdown?.nativeElement?.children[0]?.children[0];
    if (dropdownSection?.children[1]?.classList.contains('show')) {
      dropdownSection?.children[0]?.click();
    }
  }
}
